var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJira(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.952 28.8c2.787-2.787 2.787-7.366 0-10.153l-9.357-9.29-4.247 4.247c-.464.464-.464 1.194 0 1.593L13.952 28.8zM27.555 13.604L13.952 0l-.067.066a7.13 7.13 0 000 10.087l9.357 9.29 4.247-4.247c.53-.464.53-1.194.066-1.592z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.952 10.087a7.13 7.13 0 010-10.087L4.197 9.688l5.044 5.044 4.711-4.645z",
    fill: "url(#jira_svg__paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.597 14.002l-4.645 4.645c2.787 2.787 2.787 7.365 0 10.152l9.755-9.754L18.597 14z",
    fill: "url(#jira_svg__paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jira_svg__paint0_linear",
    x1: 13.719,
    y1: 5.273,
    x2: 7.835,
    y2: 11.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jira_svg__paint1_linear",
    x1: 14.317,
    y1: 23.341,
    x2: 20.761,
    y2: 16.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908,
    stopColor: "#fff"
  })))));
}

export default SvgJira;